<template>
    <section class="c-banner">
        <div
            v-if="content.custom"
            class="c-banner__title"
        >
            <p v-text="splitSentence(content.custom?.field1)" />
        </div>
        <div class="c-banner__actions">
            <div class="banner-btn-solid">
                <y-button
                    color="primary"
                    :tag="isLink(content.custom['field7']) ? 'a' : 'router-link'"
                    :to="content.custom['field7']"
                    :href="content.custom['field7']"
                    :content="content.custom['field6']"
                    size="medium"
                    flat
                    :no-padding="true"
                />
            </div>
        </div>
    </section>
</template>

<script>
    import { isLink } from '@/helpers/helpers';

    export default {
        name : 'ForPagesBanner',
        props: {
            content: Object,
        },

        methods: {
            isLink,
            /**
             * split text with /n
             *
             * @param {string}text
             * @returns {string}
             */
            splitSentence(text) {
                return text.split('\\n').join('\n');
            },
        },
    };
</script>

<style lang="scss" src="./banner.scss"></style>
